import Common_Contact_Form from "./common_contact_form";
import Footer from "./Footer";
import Header from "./Header";
import React from "react";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";

const FinancePartner = () => {
  const location = useLocation(); // Get the current location (path)

  const meta = metaConfig.financepartner;

  return (
    <div>
      <SEO {...meta} />

      <div class="container-fluid position-relative p-0">
        <div class="w-100 me-3 top_head">
          <div class="top_head align-items-center"></div>
        </div>
        <Header />
      </div>

      <div class="container-fluid Finance_partner bg-breadcrumb">
        <div class="container text-center py-5" style={{ maxWidth: "900px" }}>
          <ol
            class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          ></ol>
          <h4
            class="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Fueling Innovation and Growth
          </h4>
        </div>
      </div>
      <div
        class="modal fade"
        id="searchModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content rounded-0">
            <div class="col-lg-12 m-auto modal-header justify-content-lg-end">
              <button
                type="button"
                class="btn-close justify-content-lg-end text-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="col-lg-9 m-auto modal-header align-items-center text-center">
              <h4
                class="modal-title mb-0 m-auto text-white"
                id="exampleModalLabel"
              >
                Search by keyword
              </h4>
            </div>
            <div class="modal-body align-items-center">
              <div class="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  class="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span
                  id="search-icon-1"
                  class="input-group-text btn border p-3"
                >
                  <i class="fa fa-search text-white"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid innercontain ktig_services_page finance_details_1 overflow-hidden pt-5">
        <div class="container">
          <div class="row col-xl-10 pb-0 m-auto g-5">
            <div
              class="text-center mt-0 mx-auto wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <h1 class="display-3 text-capitalize text-white">
                Finance Partners
              </h1>
            </div>

            <div
              className="page_details_inner wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <p className="text-white text-left">
                Fiscal allies play a pivotal role in KTIG's journey toward
                growth, innovation, and success. Our partners are more than
                funding sources—they are trusted collaborators who share our
                vision for driving progress and delivering value to our
                stakeholders. By working closely with fiscal allies, KTIG can
                access the necessary capital to fuel ambitious projects, invest
                in cutting-edge technologies, and expand into new markets. Our
                fiscal allies bring expertise, strategic guidance, and a shared
                commitment to long-term sustainability. They help us navigate
                complex economic landscapes, identify new opportunities, and
                optimize resource allocation. Together, we build innovative
                solutions that create meaningful impacts for businesses and
                communities alike.
              </p>
              <p className="text-white text-left">
                KTIG values relationships built on trust, transparency, and
                mutual growth. We carefully select financial partners who align
                with our goals and values, ensuring a strong foundation for
                collaboration. By combining their financial acumen with KTIG’s
                expertise and vision, we aim to shape a brighter and more
                connected future.
              </p>
              <p className="text-white text-left">
                With the support of our fiscal allies, KTIG continues to push
                boundaries, tackle challenges, and create opportunities that
                drive lasting value for our clients, stakeholders, and society
                as a whole.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid finance_details_1 overflow-hidden pb-5 p-0">
        <Common_Contact_Form />
      </div>

      <Footer />

      <a
        href="#"
        class="btn btn-secondary btn-lg-square rounded-circle back-to-top"
      >
        <i class="fa fa-arrow-up"></i>
      </a>
    </div>
  );
};

export default FinancePartner;
